module.exports = __webpack_public_path__ + "static/img/agentega.6718760.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/thumbnails/projects/agentega.png
// module id = QaNs
// module chunks = 0